import React from 'react';
import { Button, FormGroup, Alert } from 'react-bootstrap';
import { IForgotPasswordProps } from '../../types/propTypes';
import { IForgotPasswordState } from '../../types/stateTypes';
import LoginService from './../../services/login/login-service';
import { IAuthResponse, IForgotPasswordFormField } from '../../models/login';
import { Common } from '../../utils/constants';
import { Formik, Field } from 'formik';
import { ReactstrapInput } from '../../components/reactstrap-formik';
import { ForgotPassworValidationSchema } from '../../validation/login/login-validation';
import images from '../../assets/images';
import { companyNameReplace } from '../../utils';
class ForgotPasswordForm extends React.Component<IForgotPasswordProps, IForgotPasswordState> {
    state: IForgotPasswordState;
    loginService: LoginService;
    private initialState: IForgotPasswordFormField = {
        Email: '',
    };
    constructor(props: IForgotPasswordProps) {
        super(props);
        this.state = {
            apiError: '',
        };
        this.loginService = new LoginService();
    }

    handleBackButton = () => {
        this.props.onChangeStage(Common.AuthStage.SIGNIN);
    };

    handleForgotPassword = (value: IForgotPasswordFormField) => {
        return this.loginService
            .forgotPassword(value)
            .then(async (res: IAuthResponse) => {
                this.setState({ apiError: '' });
                this.props.onChangeStage(Common.AuthStage.CHANGE_PASSWORD_WITH_VERIFICATION_CODE, value.Email);
            })
            .catch((error) => {
                this.setState({ apiError: this.props.t('login.errors.inValidEmailAddress') });
            });
    };

    render() {
        const { t, children } = this.props;
        return (
            <>
                <a className="logo" href="/" title={companyNameReplace(t('login.button.instavolt'))}>
                    <img
                        className="d-block"
                        src={images.logoPNG}
                        alt={companyNameReplace(t('login.button.instavolt'))}
                    />
                </a>
                <div className="login-block">
                    <button
                        type="button"
                        className="btn btn-icon btn-link pr-0 btn-back"
                        title={t('login.button.back')}
                        onClick={this.handleBackButton}
                    >
                        <img className="icon" src={images.backArrowSVG} alt={t('login.button.back')} />
                    </button>
                    <div className="title-outer pb-3">
                        <h1 className="title pb-2">{t('login.forgotPassword.header')}</h1>
                        <p>{t('login.forgotPassword.subheader')}</p>
                    </div>

                    {this.state.apiError.length > 0 && (
                        <Alert key="errorAlert" variant="danger">
                            {this.state.apiError}
                        </Alert>
                    )}
                    <Formik
                        initialValues={this.initialState}
                        onSubmit={this.handleForgotPassword}
                        validationSchema={ForgotPassworValidationSchema(t)}
                    >
                        {(props) => {
                            const { handleSubmit } = props;
                            return (
                                <form onSubmit={handleSubmit} autoComplete="off">
                                    <Field
                                        type="text"
                                        name="Email"
                                        id="Email"
                                        maxLength={50}
                                        placeholder={t('login.forgotPassword.placeholderEmail')}
                                        component={ReactstrapInput}
                                    />
                                    <FormGroup>
                                        <Button
                                            type="submit"
                                            color="primary"
                                            className="btn mt-2 w-100"
                                            title={t('login.button.resetMyPassword')}
                                        >
                                            <span>{t('login.button.resetMyPassword')}</span>
                                        </Button>
                                    </FormGroup>
                                </form>
                            );
                        }}
                    </Formik>
                    {children}
                </div>
            </>
        );
    }
}
export default ForgotPasswordForm;
